import { CountryIso2Code } from '../../models/country/country-iso-2-code.enum';
import { CountryIso3Code } from '../../models/country/country-iso-3-code.enum';
import { CountryIsoNumber } from '../../models/country/country-iso-number.enum';

export function countryIsoNumberFactory(
  countryIso?: CountryIsoNumber | CountryIso2Code | CountryIso3Code,
): CountryIsoNumber {
  switch (countryIso) {
    case CountryIso2Code.Ireland:
    case CountryIso3Code.Ireland:
    case CountryIsoNumber.Ireland:
      return CountryIsoNumber.Ireland;
    case CountryIso2Code.GreatBritain:
    case CountryIso3Code.GreatBritain:
    case CountryIsoNumber.GreatBritain:
    default:
      return CountryIsoNumber.GreatBritain;
  }
}
